import { useContext, useEffect, useState } from 'react';
import styles from './reviews.module.scss';
import { PaginationType, ReviewType } from '@/types';
import { RestAPI } from '@/scripts';
import { API } from '@/data';
import { GlobalContext } from '@/context';
import { message, Pagination, Spin } from 'antd';
import { ReviewCardComp } from '@/components';
export default function BrandReviewsComp({
  slug
}: {
  slug: string;
}) {
  const langText = useContext(GlobalContext).langText;
  const lang = langText.brandDetail;
  const [reviewsList, setReviewsList] = useState<{
    data: PaginationType<ReviewType>;
    page: number;
  }>();
  const getComments = (page: number) => {
    setReviewsList(undefined);
    RestAPI.get<PaginationType<ReviewType>>(API.order.public, {
      lang: langText.lang,
      page_size: 4,
      page,
      service__brand__slug: slug,
      ordering: '-created_at'
    }).then(res => setReviewsList({
      data: res.data,
      page
    })).catch(() => message.error(lang.errorMessage));
  };
  useEffect(() => getComments(1), []);
  return <>
            <div className={`${styles['review-list']} mb-10 ${reviewsList?.data.count === 0 ? 'd-none-i' : ''}`}>
                <span className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="t-h3 t-800 t-dark1">{lang.customers_comments}</h3>
                    <p className="t-p1 t-400 t-dark3">
                        {reviewsList?.data.count} {lang.comments_service}
                    </p>
                </span>
                {!reviewsList ? <div className={`w-100 pv-6 center-content ${styles['loading']}`}>
                        <Spin />
                    </div> : <div className={`${styles['card-list']}`}>
                        {reviewsList.data.data.map((item, index) => <ReviewCardComp key={index} data={item} />)}
                    </div>}
            </div>
            <div className={`${styles['pagination-review-layout']} ${(reviewsList?.data.num_of_pages ?? 0) > 1 ? '' : 'd-none'} center-content`}>
                <div className={`${styles['pagination-review']} d-flex center-content`}>
                    <Pagination size="small" current={reviewsList?.page} pageSize={4} total={reviewsList?.data.count} showSizeChanger={false} hideOnSinglePage onChange={getComments} data-sentry-element="Pagination" data-sentry-source-file="reviews.index.tsx" />
                </div>
            </div>
        </>;
}